import { Grid } from '@material-ui/core';
import React from 'react';
import { LoadingIndicator } from 'library';
import { IGroup } from 'parent-portal/group/models';
import GroupsCarousel from './GroupsCarousel';

interface IProps {
    loaded: boolean;
    groups: IGroup[];
}

export default function TabHandler({ loaded, groups }: IProps) {
    return loaded ? (
        <GroupsCarousel groups={groups} />
    ) : (
        <Grid container>
            <LoadingIndicator />
        </Grid>
    );
}
